import React, { forwardRef, useCallback, useImperativeHandle } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Button, Modal } from 'ncoded-component-library';
import { Form } from 'react-final-form';
import useCallbackRef from 'hooks/useCallbackRef';
import { ModalRef } from 'ncoded-component-library/build/components/organisms/Modal/Modal.component';
import EmailField from 'components/EmailField';

import './SendingInvoiceToClient.styles.scss';

type SendingInvoiceToClientForm = {
  clientEmailForGeneratingInvoice: string;
};

type SendingInvoiceToClientProps = {
  className?: string;
  onSuccess?: (values?: SendingInvoiceToClientForm) => void;
};

const SendingInvoiceToClient: React.ForwardRefRenderFunction<
  ModalRef,
  SendingInvoiceToClientProps
> = (props, ref) => {
  const { className, onSuccess } = props;

  const [modal, modalRef] = useCallbackRef<ModalRef>();

  useImperativeHandle(ref, () => modal, [modal]);

  const { t } = useTranslation();

  const classes = classNames('sending-invoice-to-client', className);

  const onSubmit = useCallback(
    (values: SendingInvoiceToClientForm) => {
      onSuccess(values);
      modal.close();
    },
    [modal, onSuccess],
  );

  return (
    <Modal
      ref={modalRef}
      className={classes}
      title={t('sendingInvoiceToClient')}
    >
      {modal?.openState && (
        <Form onSubmit={onSubmit}>
          {({ handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              <p>{t('sendingInvoiceToClientDescription')}</p>

              <EmailField
                name="clientEmailForGeneratingInvoice"
                label={t('ownersEmail')}
              />

              <div className="actions">
                <Button variant="link" onClick={modal.close}>
                  {t('back')}
                </Button>
                <Button type="submit">{t('sendToClient')}</Button>
              </div>
            </form>
          )}
        </Form>
      )}
    </Modal>
  );
};

export default forwardRef(SendingInvoiceToClient);
